module.exports = __webpack_public_path__ + "img/avatar1.4c803cec.png";